import React from "react";
import { DateTime } from "luxon";
import { Link } from "react-router-dom";
import typesContext from "../../contexts/types";
import Tags from "../../components/tags/Tags";
import Text from "../../components/typography/Text";
import Button from "../../components/buttons/Button";
import Dialog from "../../components/dialogs/Dialog";
import fetchApi from "../../fetchApi";
import Candidates from "../Candidates/List";

const formatDate = date => DateTime.fromISO(date).toFormat("y, MMMM d");

const Mission = ({
  mission,
  loggedUser,
  refresh,
  canApply,
  projectSlug,
  showAllApplications,
}) => {
  const [isOpen, toggle] = React.useReducer(s => !s, false);
  const [showDeleteDialog, toggleDeleteDialog] = React.useReducer(
    s => !s,
    false
  );
  const [showCloseDialog, toggleCloseDialog] = React.useReducer(s => !s, false);
  const [applicationsCount, setApplicationsCount] = React.useState(0);
  const { skills } = React.useContext(typesContext);
  const {
    id: missionId,
    title,
    skill = [],
    postingDate,
    description,
    close,
    modified,
  } = mission || {};

  const missionSkills =
    skills && skill
      ? skill
          .map(skillId => {
            const skillData = skills.find(({ id }) => id === skillId);
            return skillData ? skillData.name : null;
          })
          .filter(Boolean)
      : [];

  const deleteMission = async () => {
    try {
      const result = await fetchApi(`/mission/${missionId}`, {
        method: "delete",
      });
      if (result && result.status === "trash") {
        toggleDeleteDialog();
        refresh();
      } else {
        alert("Impossible de supprimer");
        throw new Error(result);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const closeMission = async () => {
    try {
      await fetchApi(`/mission/${missionId}`, {
        method: "post",
        body: { close: true },
      });
      refresh();
      toggleCloseDialog();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <div className={`oMission ${isOpen ? "-open" : "-close"}`}>
        {loggedUser && (
          <div className="oMission_edition">
            <div>
              <Link
                to={{ pathname: "/project/editmission", state: { mission } }}
              >
                <Button outlined rounded icon="pencil" iconSize="16px">
                  Edit
                </Button>
              </Link>
              {!close && (
                <Button outlined rounded onClick={toggleCloseDialog}>
                  Close mission
                </Button>
              )}
            </div>
            <Button outlined rounded icon="close" onClick={toggleDeleteDialog}>
              Delete
            </Button>
          </div>
        )}
        <div className="oMission_content">
          <div className="oMission_toggle" onClick={toggle} />
          <div className="oMission_resume">
            <h4 onClick={toggle}>
              <span>{title.rendered}</span>
            </h4>
            <Tags tags={missionSkills} />
            <div className="oMission_metas">
              {postingDate && (
                <div className="oMission_meta">
                  <h5>Posted on</h5>
                  <Text small>
                    {DateTime.fromFormat(postingDate, "y/M/d").toFormat(
                      "y, MMMM d"
                    )}
                  </Text>
                </div>
              )}
            </div>
            {isOpen && (
              <>
                <div className="oMission_description">
                  <Text>{description}</Text>
                </div>
                <div className="oMission_actions">
                  {canApply ? (
                    <Link
                      to={{ pathname: "/project/workwith", state: { mission } }}
                    >
                      <Button icon="send" rounded>
                        Apply
                      </Button>
                    </Link>
                  ) : (
                    <div />
                  )}
                  <div className="oMission_updated">
                    <Text superSmall>Last update: {formatDate(modified)}</Text>
                  </div>
                </div>
              </>
            )}
            {loggedUser && (
              <Candidates
                mission={mission}
                projectSlug={projectSlug}
                showAllApplications={showAllApplications}
                setTotalCount={setApplicationsCount}
              />
            )}
          </div>
        </div>
      </div>
      <Dialog show={showDeleteDialog} toggle={toggleDeleteDialog}>
        <div className="dialog_content">
          <h4>Delete mission</h4>
          <Text small>
            Are you sure you want to delete "{title.rendered}" ?
          </Text>
          <div className="dialog_actions">
            <Button outlined rounded onClick={toggleDeleteDialog}>
              Cancel
            </Button>
            <Button rounded onClick={deleteMission}>
              Delete
            </Button>
          </div>
        </div>
      </Dialog>
      <Dialog show={showCloseDialog} toggle={toggleCloseDialog}>
        <div className="dialog_content">
          <h4>Close this mission ?</h4>
          <Text small>
            <strong>{applicationsCount} email(s)</strong> will be sent to inform
            candidates that this mission is definitely closed.
          </Text>
          <div className="dialog_actions">
            <Button outlined rounded onClick={toggleCloseDialog}>
              Cancel
            </Button>
            <Button rounded onClick={closeMission}>
              Confirm
            </Button>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default Mission;
